// Model.js
// -----------------------
// @module Case
define("Jeske.PLPBrandName.PLPModule.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
});
});
